import { render } from "./BedTypesTab.vue?vue&type=template&id=7f761e30"
import script from "./BedTypesTab.vue?vue&type=script&lang=js"
export * from "./BedTypesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__